export const USER_ID_LENGTH = 36;
export const PROJECT_ID = "9471";
export const PERSIST_USER_ID_KEY = "persistUserId";

export const UNITPAY_BASE_URL = "https://pay.anonchat.io";
export const ANONCHAT_PROD_URL = "https://anonchatapi.stivisto.com";
export const ANONCHAT_DEV_URL = "http://localhost:5001";
